module.exports = __webpack_public_path__ + "static/media/plant.fba8b384.svg";